import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        studentKelulusan : [{}],
        studentGraduationList : [{}],
    },
    getters: {
        getStudentKelulusan: state => state.studentKelulusan,
        getStudentGraduationList: state => state.studentGraduationList,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setStudentKelulusan(state, { resp }){
            if (resp) {
                state.studentKelulusan = resp.data.data
            } else {
                state.studentKelulusan = [{}]
            }
        },
        setStudentGraduationList(state, { resp }){
            if (resp) {
                state.studentGraduationList = resp.data.data
            } else {
                state.studentGraduationList = [{}]
            }
        },
    },
    actions: {
        getStudentKelulusan({commit}){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/student-progress/graduation?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setStudentKelulusan', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        getStudentGraduationList({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/student-progress/admin-graduation/'+param.tahunAjaranId+'/'+param.userId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setStudentGraduationList', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        deleteKelulusan({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/student-progress/delete-graduation?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
